import React from "react";
import BasePage from "../../base/BasePage";
import HomePresenter from "./HomePresenter";
import "./HomePage.css";
import HeroSection from "./components/HeroSection";
import SolutionsSection from "./components/SolutionsSection";
import ExtraSection from "./components/ExtraSection";
import ProjectsSection from "./components/ProjectsSection";
import ClientsSection from "./components/ClientsSection";
import BottomSection from "./components/BottomSection";
import FooterSection from "./components/FooterSection";
import NavBar1 from "../../components/Navbar1";

class HomePage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new HomePresenter(this);
    this.state = {
      projects: null,
      clients: null,
      heroContent: null,
      loadingHero: true,
      showHero: false,
      showCards: false,
      showExtraSection: false,
      showProjects: false,
      showClients: false,
      showImage: false,
      currentSlide: 0,
      projectSlideIndex: 0,
      isSliding: false,
      slideDirection: "left",
      skipTransition: false,
    };

    this.solutionRef = React.createRef();
    this.extraSectionRef = React.createRef();
    this.projectsRef = React.createRef();
    this.clientsRef = React.createRef();
    this.bottomRef = React.createRef();
    this.solutionSliderRef = null;
  }

  componentDidMount() {
    this.presenter.initialize();
  }

  componentWillUnmount() {
    this.presenter.cleanup();
  }

  showError(error) {
    alert(error.message || "An error occurred");
  }

  nextSlide = () => {
    this.setState((prev) => ({ currentSlide: prev.currentSlide + 1 }));
  };

  nextProjectSlide = () => {
    this.presenter.nextProjectSlide();
  };

  prevProjectSlide = () => {
    this.presenter.prevProjectSlide();
  };

  handleScroll = () => {
    this.presenter.handleScroll();
  };

  render() {
    const {
      heroContent,
      loadingHero,
      showHero,
      showCards,
      showExtraSection,
      currentSlide,
      skipTransition,
    } = this.state;
    console.log("projects", this.state.projects);

    if (loadingHero) return <p>Loading hero content...</p>;

    const solv = this.presenter.getSolutionsSectionContent();
    const base = solv.solutions;
    const ext = [...base, base[0]];
    const totalSlides = ext.length;

    return (
      <>
        <NavBar1 className="shadow-sm " />

        <HeroSection showHero={showHero} heroContent={heroContent} />

        <SolutionsSection
          solutionRef={this.solutionRef}
          showCards={showCards}
          currentSlide={currentSlide}
          skipTransition={skipTransition}
          base={solv.solutions}
          ext={ext}
          totalSlides={totalSlides}
          cardStyle={solv.cardStyle}
          rowStyle={solv.rowStyle}
          imageStyle={solv.imageStyle}
          onSlideReset={() => {
            this.setState({ skipTransition: true, currentSlide: 0 }, () => {
              requestAnimationFrame(() => {
                this.setState({ skipTransition: false });
              });
            });
          }}
        />

        <ExtraSection
          extraSectionRef={this.extraSectionRef}
          showExtraSection={showExtraSection}
          content={this.presenter.getExtraSectionContent()}
        />

        <ProjectsSection
          projectsRef={this.projectsRef}
          showProjects={this.state.showProjects}
          projects={this.state.projects}
          projectSlideIndex={this.state.projectSlideIndex}
          nextProjectSlide={this.nextProjectSlide}
          prevProjectSlide={this.prevProjectSlide}
          isSliding={this.state.isSliding}
          slideDirection={this.state.slideDirection}
        />

        <ClientsSection
          clientsRef={this.clientsRef}
          showClients={this.state.showClients}
          presenter={this.state.clients}
        />

        <BottomSection
          showImage={this.state.showImage}
          presenter={this.presenter}
          bottomRef={this.bottomRef}
        />
        <FooterSection footerText={this.presenter.getFooterContent().text} />
      </>
    );
  }
}

export default HomePage;
